export default __webpack_public_path__ + "static/media/ic-show-eye.d196b80f.svg";